var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"transparent"}},[_c('div',{},[_c('div',{staticClass:"clock-previewca bubblefont",class:_vm.foreColor,attrs:{"id":"bubbleclock"}},[_c('span',{staticClass:"bubbletime"},[_c('p',{staticClass:"bubbleampm"},[_vm._v(_vm._s(_vm.ampm))]),_vm._v(_vm._s(_vm.hours)+":"+_vm._s(_vm.minutes))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }